module.exports = __webpack_public_path__ + "img/icon.3ddb77d3.png";